
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/arrow-right","xmlns":"http://www.w3.org/2000/svg","width":"19.681","height":"19.681","viewBox":"0 0 19.681 19.681"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.87 9.84h13.8","fill":"none","stroke":"#484f5b","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    